// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const GreenRedSwitch = withStyles(theme => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    color: 'white',
    '& + $track': {
      backgroundColor: 'red',
      opacity: 1,
      border: 'none',
    },
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const StatusSwitch = ({ rowData, item, changeStatus }) => {
  const [checked, setChecked] = React.useState(item);

  function toggleSwitch(e) {
    e.preventDefault();
    setChecked(prev => !prev);
    changeStatus(e, rowData.id, rowData);
  }
  return (
    <div>
      <FormControlLabel
        control={
          <GreenRedSwitch
            checked={checked}
            onChange={toggleSwitch}
            name="checkedB"
          />
        }
      />
    </div>
  );
};

StatusSwitch.propTypes = {
  rowData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  item: PropTypes.oneOfType([PropTypes.object]).isRequired,
  changeStatus: PropTypes.func.isRequired,
};

export default StatusSwitch;
